import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '.';

export interface ISalesItemTypeModel extends IModel {
  salesItemTypeId: number;
  name: string;
  sortOrder: number;
  allowAttributes: boolean;
}

export class SalesItemTypeModel
  extends Model
  implements ModelRecord<ISalesItemTypeModel>
{
  salesItemTypeId: number;
  name: string;
  sortOrder: number;
  allowAttributes: boolean;

  constructor(params?: Partial<ISalesItemTypeModel>) {
    super(params);
    this.salesItemTypeId = defaultTo(params?.salesItemTypeId, 0);
    this.name = defaultTo(params?.name, '');
    this.sortOrder = defaultTo(params?.sortOrder, 0);
    this.allowAttributes = defaultTo(params?.allowAttributes, false);
  }
}
